import React from 'react';
import { BiEdit, BiPlus, BiTrash } from 'react-icons/bi';

import Bouton from '../../UI/Bouton/Bouton';
import Tableau from '../../UI/tableau/Tableau';

import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import S from './TableauFunctions.module.scss';

const COLUMN_CONFIG = [
  ['id_function', 'ID', 90, 0.6],
  ['name', 'Nom', 220, 1.8],
];

const createColumn = (dataField, text, minWidth, flex) => ({
  dataField,
  text,
  sort: true,
  minWidth,
  flex,
});

const TableauFunctions = ({
  functionSelectionnee,
  editerFunction,
  creerFunction,
  supprimerFunction,
  functions,
}) => {
  const handleEdit = (e, func) => {
    e.stopPropagation();
    if (typeof editerFunction === 'function') editerFunction(func);
  };

  const handleDelete = (e, func) => {
    e.stopPropagation();
    if (typeof supprimerFunction === 'function') {
      supprimerFunction(func);
    }
  };

  const selectRow = {
    mode: 'radio',
    onSelect: (row) => {
      if (typeof functionSelectionnee === 'function')
        return functionSelectionnee(row);
    },
  };

  const colonnes = [
    ...COLUMN_CONFIG.map(([dataField, text, minWidth, flex]) => {
      const column = createColumn(dataField, text, minWidth, flex);
      if (dataField === 'id_function') {
        return {
          ...column,
          formatter: (cell, row) => row.id_function || row.id,
        };
      }
      return column;
    }),
    {
      dataField: 'actions',
      text: 'Actions',
      isDummyField: true,
      flex: 0.8,
      minWidth: 140,
      formatter: (cell, row) => (
        <div className={S.actionsContainer}>
          <Bouton
            type={type_btn.secondary}
            rond={true}
            taille="small"
            cliquer={(e) => handleEdit(e, row)}
            ajoutClass={`${S.actionButton} ${S.editButton}`}
          >
            <BiEdit size={14} />
          </Bouton>
          <Bouton
            type={type_btn.danger}
            rond={true}
            taille="small"
            cliquer={(e) => handleDelete(e, row)}
            ajoutClass={`${S.actionButton} ${S.deleteButton}`}
          >
            <BiTrash size={14} />
          </Bouton>
        </div>
      ),
    },
  ];

  return (
    <div className={S.conteneurTableau}>
      <div className={S.filtresContainer}>
        <Bouton
          type={type_btn.success}
          cliquer={creerFunction}
          ajoutClass={S.boutonCreer}
        >
          <BiPlus size={16} /> Créer une fonction
        </Bouton>
      </div>
      <div className={S.tableauContainer}>
        <Tableau
          donnees={functions}
          colonnes={colonnes}
          selectionnerLignes={selectRow}
          cleLigne="id_function"
          messageVide="Aucune fonction trouvée"
          ajoutClass={S.tableau}
          hide_general_search={false}
        />
      </div>
    </div>
  );
};

export default TableauFunctions;
